import { createSlice } from "@reduxjs/toolkit";

const initialSpiffState = {
  plans: {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    planForEdit: undefined,
    error: null,
    message: {
      error: null,
      success: null,
    },
  },
  report: {
    listLoading: false,
    detailEntities: [],
    detailTotal: 0,
    summaryEntities: [],
    summaryTotal: 0,
    error: null,
  },
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const spiffSlice = createSlice({
  name: "spiff",
  initialState: initialSpiffState,
  reducers: {
    catchError: (state, action) => {
      state.plans.message.error =
        action.payload.error.response && action.payload.error.response.data
          ? [...action.payload.error.response.data.errors]
          : action.payload.error.message;
      if (action.payload.callType === callTypes.list) {
        state.plans.listLoading = false;
      } else {
        state.plans.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.plans.error = null;
      state.plans.message.success = null;
      if (action.payload.callType === callTypes.list) {
        state.plans.listLoading = true;
      } else {
        state.plans.actionsLoading = true;
      }
    },
    // findSpiffPlans
    plansFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.plans.listLoading = false;
      state.plans.error = null;
      state.plans.entities = entities;
      state.plans.totalCount = totalCount;
    },
    // findSpiffPlanById
    planFetched: (state, action) => {
      state.plans.actionsLoading = false;
      state.plans.error = null;
      state.plans.planForEdit = action.payload.planForEdit;
    },
    // createSpiffPlan
    planCreated: (state, action) => {
      state.plans.actionsLoading = false;
      state.plans.error = null;
      state.plans.message.success = action.payload.message;
      state.plans.entities = [action.payload.plan, ...(state.plans.entities || [])];
    },
    // updateSpiffPlan
    planUpdated: (state, action) => {
      state.plans.actionsLoading = false;
      state.plans.error = null;
      state.plans.message.success = action.payload.message;
      if (action.payload.plan) {
        state.plans.entities = (state.plans.entities || []).map((entity) =>
          entity.id === action.payload.plan.id ? action.payload.plan : entity
        );
      }
    },
    // deleteSpiffPlan
    planDeleted: (state, action) => {
      state.plans.actionsLoading = false;
      state.plans.error = null;
      state.plans.message.success = action.payload.message;
      state.plans.entities = (state.plans.entities || []).filter((entity) => String(entity.id) !== String(action.payload.id));
    },
    successActionCompleted: (state) => {
      state.plans.message.success = null;
    },
    errorActionCompleted: (state) => {
      state.plans.message.error = null;
    },
    // report calls
    reportStartCall: (state) => {
      state.report.error = null;
      state.report.listLoading = true;
    },
    reportCatchError: (state, action) => {
      state.report.listLoading = false;
      state.report.error =
        action.payload.error.response && action.payload.error.response.data
          ? [...action.payload.error.response.data.errors]
          : action.payload.error.message;
    },
    reportDetailFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.report.listLoading = false;
      state.report.error = null;
      state.report.detailEntities = entities;
      state.report.detailTotal = totalCount;
    },
    reportSummaryFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.report.listLoading = false;
      state.report.error = null;
      state.report.summaryEntities = entities;
      state.report.summaryTotal = totalCount;
    },
  },
});
